import axiosInstance from "./AxiosInstance";

const getCurrentTime = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(now.getDate()).padStart(2, "0")} ${String(
    now.getHours()
  ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
    now.getSeconds()
  ).padStart(2, "0")}`;
};



export const getMindfulnessHistory = async ({ page = 1, mark_as_done }) => {
  try {
    const response = await axiosInstance.get("api/mind-fulness/index", {
      params: { page, mark_as_done },
    });
    return response.data?.data;
  } catch (error) {
    console.error("Error fetching mindfulness history:", error);
    throw error;
  }
};


export const markMindfulnessAsDone = async ({ date, title }) => {
  try {
    const response = await axiosInstance.post("api/mind-fulness/mark-as-done", {
      date,
      title,
    });
    return response.data;
  } catch (error) {
    console.error("Error marking mindfulness as done:", error);
    throw error;
  }
};


export const submitMindfulnessEntries = async (preferences) => {
  try {
    const response = await axiosInstance.post("api/mind/fullness/entries", {
      preferences,
    });
    return response.data;
  } catch (error) {
    console.error("Error submitting mindfulness entries:", error);
    throw error;
  }
};

export const createMindfulnessPlan = async () => {
  try {
    const response = await axiosInstance.post("api/mind-fulness/create/plan",{
      start_time: getCurrentTime(),
    });
    return response.data;
  } catch (error) {
    console.error("Error creating mindfulness plan:", error);
    throw error;
  }
};

export const fetchMindfulnessSteps = async () => {
  try {
    const response = await axiosInstance.get("api/mind/fullness/entries");
    return response.data;
  } catch (error) {
    console.error("Error fetching mindfulness steps:", error);
    throw error;
  }
};

export const fetchMindfulnessData = async () => {
  try {
    const response = await axiosInstance.get("api/mind-fulness");
    return response.data; 
  } catch (error) {
    console.error("Error fetching mindfulness data:", error);
    throw error;
  }
};